import React from "react";

// EU DSA Specialists brand logo (white, for dark backgrounds).
export function Logo({ className = "h-8" }) {
  return (
    <img
      src="/dsa-logo.png"
      alt="EU DSA Specialists"
      data-testid="brand-logo"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
}

export function Brand({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-lockup">
      <div className="flex items-center gap-2">
        <div className="grid h-6 w-6 place-items-center rounded-[5px] bg-white">
          <span className="h-3 w-3 rotate-[18deg] rounded-[3px] bg-zinc-950" />
        </div>
        <span className="text-[15px] font-extrabold tracking-tight text-zinc-50">
          ROBLOX
        </span>
      </div>
      <span className="h-5 w-px bg-zinc-700" aria-hidden />
      <div className="flex items-baseline gap-1.5">
        <span className="text-[15px] font-bold tracking-tight text-zinc-50">
          TELUS
        </span>
        {!compact && (
          <span className="text-[15px] font-light tracking-tight text-zinc-400">
            Digital
          </span>
        )}
      </div>
    </div>
  );
}

export function SidebarBrand() {
  return (
    <div className="flex items-center gap-2.5" data-testid="sidebar-brand">
      <div className="grid h-8 w-8 place-items-center rounded-md bg-white shrink-0">
        <span className="h-3.5 w-3.5 rotate-[18deg] rounded-[3px] bg-zinc-950" />
      </div>
      <div className="leading-none">
        <div className="text-[13px] font-extrabold tracking-tight text-zinc-50">
          ROBLOX
        </div>
        <div className="mt-1 text-[9px] font-semibold uppercase tracking-[0.16em] text-zinc-500">
          Trust &amp; Safety
        </div>
      </div>
    </div>
  );
}
